import * as React from 'react';
import { Link } from 'react-router-dom';

import { INavLink } from '../../interfaces/interfaces';
import { ClassName } from '../../utils/utils';

interface IBreadcrumbsProps {
    links: INavLink[];
    type?: string;
}

const Breadcrumbs = (props: IBreadcrumbsProps) => {
    return (
        <div className={ClassName('breadcrumbs', [props.type])}>
            {props.links.map((link, i) => (
                <span key={i} className="breadcrumbs__item">
                    {link.link 
                        ?
                        <Link to={link.link} className="breadcrumbs__link">
                            {link.value}
                        </Link>
                        :
                        <span className="breadcrumbs__link">
                            {link.value}
                        </span>
                    }
                </span>
            ))}
        </div>
    );
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/modules/Breadcrumbs/Breadcrumbs.tsx